import { settings } from '@alme/ui-web/settings/settings-util';

import AccessKeyManager from '@alme/ui-web/ref/accesskey';
import LanguageManager from '@alme/ui-web/ref/language';
import ChannelManager from '@alme/ui-web/ref/channel';
import SessionManager from '@alme/ui-web/ref/session';
import UserManager from '@alme/ui-web/ref/user';
import PageAwareness from '@alme/ui-web/ref/pageawareness';
import RequestProcessorEndSession from '@alme/ui-web/ref/request-processor-end-session';
import UiVersionNumberRequestProcessor from '@alme/ui-web/ref/request-processor-ui-version-number';
import MarkdownResponseHandler from '@alme/ui-web/ref/response-handler-markdown';
import ResponseHandlerLaunchMessageProcess from '@alme/ui-web/ref/response-handler-launch-message-process';
import { ResponseHandlerInlineSurveyLinks } from '@alme/ui-web/ref/message-renderer-inline-survey-links';
import LanguageSpecificSettingsOverride from '@alme/ui-web/ref/language-specific-settings-override';
import CustomResponseHandlerCallToAction from '../modules/custom-message-renderer-call-to-action/response-handler-call-to-action';
import RequestProcessorClientDatetimeOffset from '@alme/ui-web/ref/request-processor-client-datetime-offset';

import InitializationDataProcessor from '../modules/request-processor-initialization-data/initializationData';
import ProductInfo from '../modules/productinfo/productinfo';
import GetConversationTranscript from '../modules/get-conversation-transcript/get-conversation-transcript';
import ResponseHandlerGoogleAnalytic from '../modules/response-handler-google-analytic/response-handler-google-analytic';
import InputLockResponseHandler from '../modules/response-handler-input-lock/response-handler-input-lock';
import ResponseProcessorDebugHandler from '../modules/response-processor-debug/response-processor-debug';
import TriggerAppEventResponseHandler from '../modules/response-handler-trigger-appevents/response-handler-trigger-appevents';
import CheckCoBrowseResponseHandler from '../modules/response-handler-checkcobrowse/response-handler-checkcobrowse';
import EmbeddedIvaRequestProcessor from '../modules/request-processor-embedded-iva/request-processor-embedded-iva';
import WebMessagingResponseHandler from '../modules/response-handler-webmessaging/response-handler-webmessaging';
let inputRequestProcessors, responseHandlers;

function setupInputRequestProcessors(components) {
    components.accessKeyManagerRequestProcessor = components.accessKeyManager.getRequestProcessor();
    components.languageManagerRequestProcessor = components.languageManager.getRequestProcessor();
    components.channelManagerRequestProcessor = components.channelManager.getRequestProcessor();
    components.sessionManagerRequestProcessor = components.sessionManager.getRequestProcessor();
    components.userManagerRequestProcessor = components.userManager.getRequestProcessor();
    components.pageAwarenessRequestProcessor = components.pageAwareness.getRequestProcessor();
    components.endSessionRequestProcessor = new RequestProcessorEndSession(null);
    components.uiVersionNumberRequestProcessor = new UiVersionNumberRequestProcessor();
    
    components.productInfoRequestProcessor = components.productInfo.getRequestProcessor();
    components.clientDatetimeOffsetRequestProcessor = new RequestProcessorClientDatetimeOffset(settings);
    components.initializationDataProcessor = new InitializationDataProcessor(settings);
    components.embeddedIvaRequestProcessor = new EmbeddedIvaRequestProcessor(settings);
    components.initializationDataProcessorRequestProcessor = components.initializationDataProcessor.getRequestProcessor();

    inputRequestProcessors = [
        components.accessKeyManagerRequestProcessor,
        components.sessionManagerRequestProcessor,
        components.userManagerRequestProcessor,
        components.languageManagerRequestProcessor,
        components.channelManagerRequestProcessor,
        components.pageAwarenessRequestProcessor,
        components.productInfoRequestProcessor,
        components.initializationDataProcessorRequestProcessor,
        components.requestProcessorChatAllowed.getRequestProcessor(),
        components.embeddInputHandler.getRequestProcessor(),
        components.endSessionRequestProcessor,
        components.uiVersionNumberRequestProcessor,
        components.inputboxLockMutator.getRequestProcessor(),
        components.clientDatetimeOffsetRequestProcessor,
        components.embeddedIvaRequestProcessor
    ];
}

function setupResponseHandlers(components) {
    
    components.getHistoryResponseHandler = components.initializeGetHistory.getResponseHandler();
    components.userManagerResponseHandler = components.userManager.getResponseHandler();
    components.getHistoryWatcherResponseHandler = components.historyWatcher.getResponseHandler();
    components.markdownProcessor = new MarkdownResponseHandler(settings, null);
    components.ponLaunchMessageProcessor = new ResponseHandlerLaunchMessageProcess(settings);
    components.responseHandlerGoogleAnalytic = new ResponseHandlerGoogleAnalytic(settings);
    components.inlineSurveyLinksResponseHandler = new ResponseHandlerInlineSurveyLinks();
    components.feedbackResponseActionHandler = components.chatSurveyOverlay.getResponseActionHandler();
    components.callToActionResponseHandler = new CustomResponseHandlerCallToAction(settings);
    components.languageSpecificSettingsOverride = new LanguageSpecificSettingsOverride(settings);
    components.getConversationTranscript = new GetConversationTranscript(settings);
    components.accessKeyHandlerResponseHandler = components.accessKeyHandler.getResponseHandler(),
    components.inputLockResponseHandler = new InputLockResponseHandler(settings);
    components.responseProcessorDebugHandler = new ResponseProcessorDebugHandler(settings);
    components.triggerAppEventResponseHandler = new TriggerAppEventResponseHandler(settings, components.launchOffersEventUtility);
    components.checkCoBrowseResponseHandler = new CheckCoBrowseResponseHandler(settings);
    components.webMessagingResponseHandler = new WebMessagingResponseHandler(settings);
    responseHandlers = [
        components.markdownProcessor.getResponseHandler(),
        components.getHistoryWatcherResponseHandler,
        components.userManagerResponseHandler,
        components.languageSpecificSettingsOverride.getLinkOverrideResponseHandler(),
        components.liveChatFoundation.GetHistoryResponseHandler,
        components.liveChatFoundation.ResponseHandler,
        components.liveChatFoundation.ErrorResponseHandler,
        components.feedbackResponseActionHandler,
        components.getConversationTranscript.getResponseActionHandler(),
        components.getConversationTranscript.getExtResponseHandler(),
        components.advocacyChatBubble.getResponseHandler(),
        components.accessKeyHandlerResponseHandler,
        components.initializationDataHandler.getResponseHandler(),
        components.inputboxLockMutator.getResponseHandler(),
        components.almeNotificationsApi.getResponseHandler(),
        components.callToActionResponseHandler,
        components.inputLockResponseHandler,
        components.responseProcessorDebugHandler,
        components.triggerAppEventResponseHandler,
        components.webMessagingResponseHandler,
        components.inlineSurveyLinksResponseHandler,
        components.ponLaunchMessageProcessor,
        components.responseHandlerGoogleAnalytic,
        components.checkCoBrowseResponseHandler,
        components.initializeGetConfiguration,
    ];
}

function setupConversation(components, conversation) {

    //modules that have more than one component
    components.accessKeyManager = new AccessKeyManager();
    components.languageManager = new LanguageManager();
    components.channelManager = new ChannelManager();
    components.sessionManager = new SessionManager();
    components.userManager = new UserManager();
    components.pageAwareness = new PageAwareness();
    components.productInfo = new ProductInfo(settings, components.liveChatFoundation._state);
    


    setupInputRequestProcessors(components);
    setupResponseHandlers(components);

    conversation.setInputRequestProcessors(inputRequestProcessors);
    conversation.setResponseHandlers(responseHandlers);

    return components;
}

export {
    setupConversation,
    inputRequestProcessors,
    responseHandlers
};



// WEBPACK FOOTER //
// ./src/setup-conversation-components.js